import { BsFilter } from "react-icons/bs";
import { ImLocation } from "react-icons/im";
import Filter from "./filter/Filter";
import useApiService from "../../../hooks/useApiService";
import {
  getAllLocations,
  // getAllVehicleCategories,
} from "../../../services/main-service/mainService";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMasterData } from "../../../hooks/useMasterData";
import { formatCategoryName } from "../../../utils/categoryDisplayNames";
import Spinner from "../../common/spinner/Spinner";

function FilterBar() {
  const { masterData, masterDataLoading, masterDataError } = useMasterData();

  // const {
  //   data: vehicleCategoryData,
  //   loading: vehicleCategoryLoading,
  //   error: vehicleCategoryError,
  // } = useApiService({
  //   serviceCall: () => getAllVehicleCategories(),
  //   dependencies: [],
  // });

  // const {
  //   data: locationData,
  //   loading: locationLoading,
  //   error: locationError,
  // } = useApiService({
  //   serviceCall: () => getAllLocations(),
  //   dependencies: [],
  // });

  const [searchParams, setSearchParams] = useSearchParams();
  let categoryType = searchParams.get("categoryType") || "";
  let location = searchParams.get("location") || "";

  function handleFilter(
    e: React.ChangeEvent<HTMLSelectElement>,
    filterType: string
  ) {
    setSearchParams((prevSearchParams) => {
      const newParams = new URLSearchParams(prevSearchParams);
      newParams.set(filterType, e.target.value);
      newParams.set("page", "1");
      return newParams;
    });
  }

  if (masterDataLoading) return <Spinner />;
  if (masterDataError) return <p className="text-center">{masterDataError}</p>;

  return (
    <div className="d-flex justify-content-center align-items-center gap-3 gap-lg-5">
      <Filter
        Icon={BsFilter}
        iconSize={27}
        options={
          masterData?.VehicleCategories?.map((category: any) => ({
            key: category.name,
            value: formatCategoryName(category.name),
          })) ?? []
        }
        filterType="categoryType"
        handleFilter={handleFilter}
        filterValue={categoryType}
      />
      <Filter
        Icon={ImLocation}
        iconSize={20}
        options={
          masterData?.Locations?.map((location: any) => ({
            key: location,
            value: location,
          })) ?? []
        }
        filterType="location"
        handleFilter={handleFilter}
        filterValue={location}
      />
    </div>
  );
}

export default FilterBar;
